import {chain} from "mathjs";

export const convertDecimalToPercentage = (value: number | null, numberOfDecimalPlaces: number): number => {
    return value === null ? 0
        : chain(value)
            .multiply(100)
            .round(numberOfDecimalPlaces)
            .done() as number;
}